import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteContainerTypeGroupMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type DeleteContainerTypeGroupMutation = { __typename?: 'Mutation', deleteContainerTypeGroup: boolean };


export const DeleteContainerTypeGroupDocument = gql`
    mutation DeleteContainerTypeGroup($id: Int!) {
  deleteContainerTypeGroup(id: $id)
}
    `;
export type DeleteContainerTypeGroupMutationFn = Apollo.MutationFunction<DeleteContainerTypeGroupMutation, DeleteContainerTypeGroupMutationVariables>;

/**
 * __useDeleteContainerTypeGroupMutation__
 *
 * To run a mutation, you first call `useDeleteContainerTypeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContainerTypeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContainerTypeGroupMutation, { data, loading, error }] = useDeleteContainerTypeGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContainerTypeGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContainerTypeGroupMutation, DeleteContainerTypeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContainerTypeGroupMutation, DeleteContainerTypeGroupMutationVariables>(DeleteContainerTypeGroupDocument, options);
      }
export type DeleteContainerTypeGroupMutationHookResult = ReturnType<typeof useDeleteContainerTypeGroupMutation>;
export type DeleteContainerTypeGroupMutationResult = Apollo.MutationResult<DeleteContainerTypeGroupMutation>;
export type DeleteContainerTypeGroupMutationOptions = Apollo.BaseMutationOptions<DeleteContainerTypeGroupMutation, DeleteContainerTypeGroupMutationVariables>;